<template>
  <tr class="application-row">
    <td>
      <router-link :to="{ path: '/membership/applications/' + application.uuid }">
        {{ application.dropdownLabel }}
      </router-link>
    </td>
    <td>
      <div class="text-center">
        {{ application.registeredDate | short_date_format }}
      </div>
    </td>
    <td>
      <div class="text-center">{{ application.AccountType.name }}</div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="application.CreditCards.length ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="application.applicationComplete ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="application.applicationReviewed ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="application.membershipLastPaid ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <span class="badge badge-margin" :class="{
        'badge-danger': !application.cardId,
        'badge-success': application.cardId
      }">
        <span class="fa fa-id-card"></span>
        {{ !application.cardId ? 'n/a' : application.Smartcard.cardNumber }}
      </span>
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="`/membership/applications/${application.uuid}`">
        <span class="fa fa-search fa-fw"></span> View
      </router-link>
      <dropdown-input
        :is-small="true"
        label="Actions"
        label-icon="fa-check-circle"
        :dropup="true"
        :actions="applicationActions(application, loggedInUser)"
        @action="executeAction($event, application)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapGetters, mapActions } from 'vuex'
import {
  ADD_SMARTCARD,
  EMAIL_APPLICATION,
  FILL_APPLICATION,
  CHECK_APPLICATION,
  MOVE_TO_APPLICATIONS,
  CHARGE_MEMBERSHIP,
  CHARGE_SETUP,
  CHARGE_DRIVER,
  UNASSIGN_SMARTCARD,
  EDIT_APPLICATION,
  EDIT_SMARTCARD,
  APPROVE_APPLICATION,
  FLAG_APPLICATION,
  BLACKLIST_MEMBER,
  DECLINE_APPLICATION,
  DELETE_APPLICATION,
  DOWNLOAD_WELCOME_LETTER,
  SEND_GUARANTOR_FORM,
  UPLOAD_GUARANTOR_FORM,
  ADD_ACCOUNT_NOTE,
  WAIVE_MEMBERSHIP,
  UNFLAG_APPLICATION
} from '@/vuex/types'
import moment from 'moment-timezone'

export default {
  name: 'ApplicationRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    DropdownInput
  },
  computed: {
    age () {
      return moment().diff(moment(this.application.dateOfBirth), 'years')
    },
    application () {
      return {
        AccountType: {},
        DriversLicense: {},
        DriversLicenseBack: {},
        AccountNotes: [],
        PromoCodes: [],
        AmazonImages: [],
        ...this.object,
        ...this.updatedApplication
      }
    },
    ...mapGetters([
      'applicationActions',
      'loggedInUser'
    ])
  },
  data () {
    return {
      updatedAccount: {},
      url: 'https://techcar-dev.s3.amazonaws.com/'
    }
  },
  methods: {
    async executeAction (action, payload) {
      if (action === DOWNLOAD_WELCOME_LETTER) {
        return this.downloadWelcomeLetter()
      } else {
        let result = await this[action](payload)
        if (result && result.updated) this.updatedApplication = result.updated
      }
    },
    uploadGuarantor () {
      this.executeAction(UPLOAD_GUARANTOR_FORM, {
        application: this.application
      })
    },
    sendGuarantor () {
      this.executeAction(SEND_GUARANTOR_FORM, {
        application: this.application
      })
    },
    downloadWelcomeLetter () {
      window.open('/welcome-letter/' + this.application.uuid)
    },
    ...mapActions([
      ADD_SMARTCARD,
      EMAIL_APPLICATION,
      FILL_APPLICATION,
      CHECK_APPLICATION,
      MOVE_TO_APPLICATIONS,
      CHARGE_MEMBERSHIP,
      EDIT_APPLICATION,
      EDIT_SMARTCARD,
      CHARGE_SETUP,
      CHARGE_DRIVER,
      UNASSIGN_SMARTCARD,
      APPROVE_APPLICATION,
      FLAG_APPLICATION,
      BLACKLIST_MEMBER,
      DECLINE_APPLICATION,
      DELETE_APPLICATION,
      SEND_GUARANTOR_FORM,
      UPLOAD_GUARANTOR_FORM,
      ADD_ACCOUNT_NOTE,
      WAIVE_MEMBERSHIP,
      UNFLAG_APPLICATION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Application.vue